var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.255,
    height: 30.846,
    viewBox: "0 0 27.255 30.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 22",
    transform: "translate(-125.46 -25.567)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rettangolo 23",
    width: 3.053,
    height: 30.845,
    transform: "translate(125.46 25.567)",
    fill: "#ca3625"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rettangolo 24",
    width: 3.051,
    height: 30.846,
    transform: "translate(137.562 25.567)",
    fill: "#ca3625"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rettangolo 25",
    width: 3.053,
    height: 30.846,
    transform: "translate(149.663 25.567)",
    fill: "#ca3625"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBars);
export default __webpack_public_path__ + "static/media/three-bars.f192ccc80bfbf83a3e58544b3f115e74.svg";
export { ForwardRef as ReactComponent };